<div class="form-check">
  <input
    #checkbox
    class="form-check-input"
    type="checkbox"
    [id]="formConfig.id"
    [attr.name]="formConfig.name"
    [attr.aria-label]="formConfig.ariaLabel"
    [attr.ngbautofocus]="formConfig.autoFocus ? '' : undefined"
    (change)="onChange(checkbox.checked)"
    (blur)="onBlur($event)" />
  <label *ngIf="formConfig.label" class="form-check-label" [for]="formConfig.id">{{
    formConfig.label
  }}</label>
</div>
<div *ngIf="displayErrorMessage()" class="form-text">{{ errorMessage }}</div>
